<h2 mat-dialog-title>Downloading...</h2>

<mat-dialog-content>
    <p>The project will be available <a [href]="data.downloadUrl" target="_blank">here</a> in few seconds</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>
